import { WHOLE_NUMBER_REGEX } from "../constants/regex";

export const onPasteValidateNumber = (e: any) => {
  let pastedData = e?.clipboardData?.getData("Text");
  if (!WHOLE_NUMBER_REGEX.test(pastedData)) {
    return e.preventDefault();
  }
};
